import { Link } from "react-router-dom";
import Button from "../loadout/Button";

export default function EmptyState({ handle, onClearFilters }) {
  return (
    <div className="text-center py-24 px-6">
      <div className="font-display text-white text-[28px] md:text-[32px] leading-[0.95]">
        No matches in this collection.
      </div>
      <p className="mt-3 font-sans text-[14px] text-[#8A8A8A]">
        Loosen your filters or scan the full arsenal.
      </p>
      <div className="mt-6 flex flex-wrap gap-3 justify-center">
        <Button variant="primary" onClick={onClearFilters}>
          Clear filters
        </Button>
        <Link
          to={`/collections/${handle}`}
          className="font-sans text-[13px] font-semibold uppercase tracking-[0.04em] text-white underline underline-offset-4 hover:text-[#FF9F1C]"
        >
          Browse all {handle} →
        </Link>
      </div>
    </div>
  );
}
